/**
 * created by xcc
 文本
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';

export default class Text extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        let {name, onClick, style = {}} = this.props;
        return <span onClick={() => onClick()}
                     style={{cursor: "pointer", marginRight: 5, color: "#0050B3", ...style}}>{name}</span>
    }

}